var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('v-sheet',{staticClass:"px-3 py-2 background"},[_c('v-row',[_vm._t("contents")],2)],1),_vm._t("button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }